import { LogoWrapper } from '@libs/contentful';

export default function HeaderMini() {
    return (
        <div>
            {/* style required because HeaderMini is used in global-error.tsx witch doesnt support .css files */}
            <style>
                {`
                    .banner-container {
                        height: 64px;
                        border-bottom: 1px solid var(--sparky-color-neutral-200);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    @media (min-width: 560px) {
                        .banner-container {
                            height: 80px;
                        }
                    }
                `}
            </style>
            <div role="banner" className="banner-container">
                <LogoWrapper />
            </div>
        </div>
    );
}
